import { render, staticRenderFns } from "./Complaint.vue?vue&type=template&id=3400186e&scoped=true&"
import script from "./Complaint.vue?vue&type=script&lang=js&"
export * from "./Complaint.vue?vue&type=script&lang=js&"
import style0 from "./Complaint.vue?vue&type=style&index=0&id=3400186e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3400186e",
  null
  
)

export default component.exports